const AssessmentQuestionModuleClient = {
  fetch_question: "/assessment/questions/",
  resume_assessment: "/assessment/resume",
  list_assessment: "/assessment/list",
  save_answer: "/assessment/answers",
  submit_assessment: "/assessment/submit",
  logout: "/logout",
  heart_beat: "/assessment/heartbeat",
  save_code: "/save_code",
  check_subscription: "/check_subscription",
};

export default AssessmentQuestionModuleClient;
